import { render, staticRenderFns } from "./CompetitiveSection.vue?vue&type=template&id=627e8a3d&scoped=true"
import script from "./CompetitiveSection.vue?vue&type=script&lang=js"
export * from "./CompetitiveSection.vue?vue&type=script&lang=js"
import style0 from "./CompetitiveSection.vue?vue&type=style&index=0&id=627e8a3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e8a3d",
  null
  
)

export default component.exports